




































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import iwProgressionWizard from "../encoding/components/progressionWizard/ProgressionWizard.vue";
import iwPictureModal from "@/encoding/components/PictureModal.vue";
import iwEditionModal from "@/encoding/components/CloseEditionModal.vue";
import iwResetWizardModal from "@/encoding/components/ResetWizardModal.vue";
import iwWarningModal from "@/encoding/components/WarningModal.vue";

import { WizardState } from "@/shared/interfaces/WizardState.interface";

export default Vue.extend({
    name: "Encoding",
    components: {
        iwProgressionWizard: iwProgressionWizard,
        iwPictureModal: iwPictureModal,
        iwEditionModal: iwEditionModal,
        iwResetWizardModal: iwResetWizardModal,
        iwWarningModal: iwWarningModal
    },
    data: function() {
        return {
            isMobile: true as boolean,
            mainSidebarSticky: false as boolean,
            masqueradeTitleIsFixed: false as boolean,
            mainSidebarIsFixed: false as boolean
        };
    },
    computed: {
        ...mapState("FormModule", [
            "isEditionMode"
        ]),
        ...mapState("StepsWizard", {
            currentStep: state => (state as WizardState).current,
            steps: state => (state as WizardState).steps,
        }),
        isEditionMode: function(): boolean {
            return this.$store.getters["FormModule/getIsEditionMode"];
        },
        ...mapGetters("StepsWizard", [
            "currentGroup"
        ]),
        ...mapState("StepsWizard/progress", [
            "main",
            "mainMax",
            "sub",
            "subMax",
            "hasSub"
        ]),
        ...mapState("UserModule", [
            "user"
        ]),
        ...mapGetters("UserModule", [
            "isLogged",
            "isMasquerading"
        ]),
    },
    created: function() {
        // Set the first step of the funnel
        // TODO: Refactor when introduce to persist store
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
            this.mainSidebarSticky = true;
        }, () => {
            this.isMobile = true;
            this.mainSidebarSticky = false;
        });


        // check if form contains unsaved data before allowing to close window
        window.addEventListener("beforeunload", (e) => {
            if(!this.isLogged || (this.isLogged && this.isEditionMode)) {
                // TODO : check condition for allowing quitting the page
                // Cancel the event
                e.preventDefault();
                // Chrome requires returnValue to be set
                e.returnValue = "";
            }
        });

        if(this.isMasquerading) {
            let root = this.$root.$children[0] as Vue;
            if (root) {
                for(let index = 0; index < root.$children.length; index++) {
                    let topNavigation = root.$children[index] as Vue;
                    if(topNavigation) {
                        if(topNavigation.$el.className === "container--main-header") {
                            topNavigation.topNavigationIsFixed = false;
                        }
                    }
                }
            }
        }
    },

    methods: {
        handleMasqueradeTitleScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            let topNavigation = document.getElementById("masquerade-title");
            if (topNavigation) {
                if (documentScrollTop > 1) {
                    this.masqueradeTitleIsFixed = true;
                } else {
                    this.masqueradeTitleIsFixed = false;
                }
            }
        },
        handleMainSidebarScroll: function() {
            let documentElement = (
                document.scrollingElement ||
                document.documentElement ||
                document.body.parentNode ||
                document.body
            ) as HTMLElement;

            let documentScrollTop = 0;
            if(documentElement) {
                documentScrollTop = documentElement.scrollTop;
            }

            // Top Navigation
            let topNavigation = document.getElementById("main-sidebar");
            if (topNavigation) {
                if (documentScrollTop > 1) {
                    this.mainSidebarIsFixed = true;
                } else {
                    this.mainSidebarIsFixed = false;
                }
            }
        }
    }
});
